/* Bloqueo del zoom en la tienda.
   - iPhone/iPad: Safari ignora user-scalable=no, asi que se
     cortan sus gestos de pellizco (gesturestart/change/end).
   - Cualquier movil: se corta el movimiento con dos dedos.
     Con un dedo no se toca nada: scroll y carruseles siguen igual.
   - Ordenador: se corta el pellizco del trackpad (llega como
     rueda + Ctrl). Ctrl + / Ctrl - del teclado se dejan. */
(function () {
  if (window.__vsNoZoom) return;
  window.__vsNoZoom = true;

  var stop = function (event) {
    if (event.cancelable) event.preventDefault();
  };

  ['gesturestart', 'gesturechange', 'gestureend'].forEach(function (name) {
    document.addEventListener(name, stop, { passive: false });
  });

  document.addEventListener('touchmove', function (event) {
    var twoFingers = event.touches && event.touches.length > 1;
    var scaled = typeof event.scale === 'number' && event.scale !== 1;
    if (twoFingers || scaled) stop(event);
  }, { passive: false });

  document.addEventListener('wheel', function (event) {
    if (event.ctrlKey) stop(event);
  }, { passive: false });
})();
